module.exports = __webpack_public_path__ + "img/owner.78acc381.svg";